export default "__VITE_ASSET__CjEF_8MU__"